import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { DetailPanelData } from "../Common/DetailPanel"
import { formatSQLDateTime, trakrefFontFamily } from '../../utils';
import { renderWeight } from '../../Utils/weight_utils';
import { pillOrange } from '../../color_utils';

const CoolingAppliance = ({
    data: {
        alternateLeakDetectionMethod = null,
        coolingApplianceStatusID = null,
        isCoolingAppliance = false,
        systemStatusName = '',
        chargeCapacityDeterminedByName = '',
        temperatureClassName = '',
        coolingCapacity = '',
        seer = '',
        eer = '',
        eseer = '',
        oilType = null,
        currentGasWeightLBS = null,
        coolingApplianceHasApprovedAlternateLeakDetectionMethod = false,
        plannedRetirementDate = '',
        plannedRetrofitDate = '',
        plannedRetrofitOriginalDate = '',
        plannedRetrofitMaterialTypeName = '',
        cylinderAlternateLeakDetectionMethodDetails = '',
        epaRollingClassicLeakRate = 0,
        renderWashingtonLeakRate = false,
    } = {}
}) => {
    if (!isCoolingAppliance) return null;
    const automaticLeakDetector = coolingApplianceHasApprovedAlternateLeakDetectionMethod === true;
    return (
        <>
            <DetailPanelData id='SystemStatusHeader' title="OPERATIONAL STATUS" data={systemStatusName} />
            {coolingApplianceStatusID === 13 && (
                <DetailPanelData
                    id='PlannedRetirementDateHeader'
                    title="PLANNED RETIREMENT DATE"
                    data={formatSQLDateTime(plannedRetirementDate)}
                     
                />
            )}
            {coolingApplianceStatusID === 8 && (
                <>
                    <DetailPanelData
                        id='OriginalRetrofitDateHeader'
                        title="ORIGINAL RETROFIT DATE"
                        data={formatSQLDateTime(plannedRetrofitOriginalDate)}
                         
                    />
                    <DetailPanelData
                        id='PlannedRetrofitDateHeader'
                        title="PLANNED RETROFIT DATE"
                        data={formatSQLDateTime(plannedRetrofitDate)}
                         
                    />
                    <DetailPanelData
                        id='RetrofittedMaterialTypeHeader'
                        title="RETROFITTED MATERIAL TYPE"
                        data={plannedRetrofitMaterialTypeName}
                         
                    />
                </>
            )}
            <DetailPanelData id='CapacityDeterminedByHeader' title="CAPACITY DETERMINED BY" data={chargeCapacityDeterminedByName} />
            <DetailPanelData id='TemperatureClassHeader' title="TEMPERATURE CLASS" data={temperatureClassName} />
            <DetailPanelData id='CoolingCapacityHeader' title="COOLING CAPACITY" data={coolingCapacity} />
            <DetailPanelData id='SEERHeader' title="SEER" data={seer} />
            <DetailPanelData id='EERHeader' title="EER" data={eer} />
            <DetailPanelData id='ESEERHeader' title="ESEER" data={eseer} />
            <DetailPanelData id='OilTypeHeader' title="OIL TYPE" data={oilType} />
            <DetailPanelData id='currentGasWeight' title="CURRENT GAS WEIGHT" data={renderWeight(currentGasWeightLBS)} />
            {renderWashingtonLeakRate && (
                <DetailPanelData
                    id='washingtonLeakRate'
                    title='WA STATE LEAK RATE'
                    render={() => (
                        <Chip
                            size='small'
                            label={`${epaRollingClassicLeakRate}%`}
                            sx={{
                                bgcolor: pillOrange,
                                color: "#F99500",
                                fontFamily: trakrefFontFamily,
                                fontWeight: 600
                            }}
                        />
                    )}
                />
            )}
            <DetailPanelData
                id='HasApprovedAlternateLeakDetectionHeader'
                title="HAS APPROVED ALTERNATE LEAK DETECTION METHOD"
                data={alternateLeakDetectionMethod ? 'Yes' : 'No'}
                 
            />
            {alternateLeakDetectionMethod && (
                <DetailPanelData
                    id='AlternateLeakDetectionMethodHeader'
                    title="ALTERNATE LEAK DETECTION METHOD"
                    data={cylinderAlternateLeakDetectionMethodDetails}
                     
                />
            )}
            {automaticLeakDetector && (
                <DetailPanelData
                    id='AutomaticLeakDetectorHeader'
                    title="AUTOMATIC LEAK DETECTOR"
                    data={oilType}
                     
                />
            )}
        </>
    );
};

CoolingAppliance.propTypes = {
    data: PropTypes.object.isRequired
};

export default CoolingAppliance;